import Svg, { Mask, Path } from '@rd-core-svg/svg'
import type { FlagsSvgProps } from '../svg.types'

export const CaixaMedium = (props: FlagsSvgProps) => {
  return (
    <Svg width={48} height={32} viewBox="0 0 48 32" fill="none" {...props}>
      <Mask id="path-1-inside-1_22078_4088" fill="white">
        <Path d="M0 4C0 1.79086 1.79086 0 4 0H44C46.2091 0 48 1.79086 48 4V28C48 30.2091 46.2091 32 44 32H4C1.79086 32 0 30.2091 0 28V4Z" />
      </Mask>
      <Path
        d="M0 4C0 1.79086 1.79086 0 4 0H44C46.2091 0 48 1.79086 48 4V28C48 30.2091 46.2091 32 44 32H4C1.79086 32 0 30.2091 0 28V4Z"
        fill="white"
      />
      <Path
        d="M4 0V1H44V0V-1H4V0ZM48 4H47V28H48H49V4H48ZM44 32V31H4V32V33H44V32ZM0 28H1V4H0H-1V28H0ZM4 32V31C2.34315 31 1 29.6569 1 28H0H-1C-1 30.7614 1.23858 33 4 33V32ZM48 28H47C47 29.6569 45.6569 31 44 31V32V33C46.7614 33 49 30.7614 49 28H48ZM44 0V1C45.6569 1 47 2.34315 47 4H48H49C49 1.23858 46.7614 -1 44 -1V0ZM4 0V-1C1.23858 -1 -1 1.23858 -1 4H0H1C1 2.34315 2.34315 1 4 1V0Z"
        fill="#E6E6E6"
        mask="url(#path-1-inside-1_22078_4088)"
      />
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.7535 14.6542L15.7867 16.9333H17.1247L16.7579 14.6449L16.7535 14.6542ZM11.6318 19.8863L15.5976 12.1621H18.5961L20.2681 19.8863H17.6358L17.4418 18.8568H14.8881L14.3006 19.8863H11.6318ZM21.5145 19.8863L22.6633 12.1621H25.3157L24.1674 19.8863H21.5145ZM39.1559 14.6449L38.1853 16.9333H39.5227L39.1559 14.6449ZM34.0298 19.8863L37.9962 12.1621H40.9941L42.6666 19.8863H40.0339L39.8404 18.8568H37.2861L36.6986 19.8863H34.0298Z"
        fill="#0070AF"
      />
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M28.1659 16.2746H31.4897L33.7672 19.8426H30.4428L28.1659 16.2746Z"
        fill="#0070AF"
      />
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M28.5116 15.7267H31.9471L34.9309 12.1737H31.4953L28.5116 15.7267Z"
        fill="#F6822A"
      />
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M25.0764 19.8643H28.5114L31.4952 16.2679H28.0596L25.0764 19.8643Z"
        fill="#F6822A"
      />
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M26.3151 12.1302H29.5212L31.718 15.7266H28.5113L26.3151 12.1302Z"
        fill="#0070AF"
      />
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.7104 12.4386L11.4553 14.7105C10.4777 13.4346 8.2118 14.3151 8.03387 15.9045C7.80776 17.9218 9.98854 18.392 11.1752 17.2042L10.9196 19.4813C10.5655 19.6457 10.2191 19.7736 9.8772 19.8597C9.53719 19.9463 9.19641 19.9922 8.85831 19.9989C8.43323 20.0076 8.04809 19.9654 7.7011 19.8731C7.35412 19.7823 7.0401 19.638 6.76227 19.4431C6.22645 19.0725 5.83903 18.6013 5.60038 18.028C5.36173 17.4526 5.2832 16.8036 5.36451 16.0782C5.43007 15.4952 5.58529 14.9636 5.83265 14.4816C6.07789 14.0001 6.41763 13.5619 6.85023 13.1649C7.25918 12.7865 7.70454 12.5009 8.18646 12.3071C8.66653 12.1148 9.19042 12.0122 9.75671 12.0009C10.095 11.9942 10.4269 12.0261 10.7489 12.0999C11.0728 12.1731 11.3921 12.2875 11.7104 12.4386Z"
        fill="#0070AF"
      />
    </Svg>
  )
}
